import { render, staticRenderFns } from "./button.component.vue?vue&type=template&id=b97bb9a8&scoped=true&"
import script from "./button.component.vue?vue&type=script&lang=ts&"
export * from "./button.component.vue?vue&type=script&lang=ts&"
import style0 from "./button.component.vue?vue&type=style&index=0&id=b97bb9a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97bb9a8",
  null
  
)

export default component.exports